<template>
  <div class="tw-flex tw-items-center tw-bg-white tw-h-screen">
    <BannerLateral />
    <div 
      class="tw-bg-white tw-mx-auto tw-flex tw-flex-col tw-justify-between tw-h-screen" 
      @submit.prevent
    >
      <div class="tw-flex tw-items-center tw-justify-center tw-grow">
        <div class="tw-px-2 tw-max-w-[430px] sm:tw-w-[430px] tw-mb-12">
          <div class="tw-flex tw-flex-col tw-items-center tw-mb-8 tw-pt-8">
            <img
              :src="LogoEconodata"
              class="tw-mb-3"
              width="90"
              height="90"
              alt="Logo da Econodata"
            >
            <span class="tw-text-azul800 tw-font-bold tw-text-3xl tw-mb-2 tw-text-center">
              Boas-vindas à Econodata
            </span>
            <span class="tw-text-cinza1 tw-font-normal tw-text-lg">
              Entre para acessar a plataforma
            </span>
          </div>
          <form class="tw-mb-8">
            <EcdtInput
              class="tw-mb-6" 
              label="E-mail"
              placeholder="Digite o seu e-mail"
              :value="emailUsuario"
              required
              required-text="Adicione seu e-mail"
              :validator="UtilsService.validateEmail"
              validator-text="E-mail com formato inválido"
              type="email"
              @update="(e) => emailUsuario = e"
            />
            <EcdtInput 
              class="tw-mb-4"
              label="Senha"
              placeholder="Digite a sua senha"
              :value="senhaUsuario"
              required
              required-text="Adicione sua senha"
              type="password"
              senha-mostravel
              @update="(e) => senhaUsuario = e"
            />
            <div class="tw-flex tw-justify-between tw-flex-col sm:tw-flex-row">
              <button
                v-b-modal.modal-confirm-email
                class="tw-text-azul500 tw-text-sm tw-font-semibold tw-mb-2 sm:tw-mb-0"
                type="button"
                @click="modalEsqueciSenhaVisivel = true"
              >
                Esqueceu sua senha?
              </button>
              <button 
                id="plat-login-botao-entrar"
                class="botao botao-primario tw-w-full sm:tw-w-[121px]"
                type="submit"
                @click.prevent="verificarUsuarioParaLogin()"
              >
                <span v-show="!carregando">Entrar</span>
                <i
                  v-show="carregando"
                  class="fa fa-circle-o-notch fa-lg fa-spin"
                />
              </button>
            </div>
          </form>
          <div 
            v-if="showBtnCriarContaTrial()"
            class="tw-mt-4 tw-text-center"
          >
            <button
              class="tw-text-azul500 tw-text-sm tw-font-semibold"
              @click="redirectCriarContaTrial()"
            >
              Criar conta
            </button>
          </div>
          <AcessoGratuito 
            v-if="loginGratuitoVisivel"
            class="tw-py-8" 
          />
        </div>
      </div>
    </div>
    <ModalEsqueciSenha 
      :visivel="modalEsqueciSenhaVisivel"
      @senha-redefinida="abrirModal('aviso')"
      @fechar-modal="fecharModal('esqueci-senha')"
    />
    <ModalAvisoTemplate
      titulo="Redefinição de senha"
      texto-primario="E-mail de recuperação enviado"
      texto-secundario="Caso o e-mail informado esteja cadastrado, você receberá uma mensagem com as instruções para redefinir sua senha."
      :visivel="modalAvisoVisivel"
      @fechar-modal="fecharModal('aviso')"
    />
    <EcdtToast 
      nome="toast-login-incorreto"
      variante="aviso"
      texto-corpo="Login e/ou senha inválidos."
    />
    <EcdtToast 
      nome="toast-conta-inativa"
      variante="aviso"
      texto-corpo="No momento, sua conta está indisponível. Por favor, entre em contato através do financeiro@econodata.com.br ou pelo 51 3024.5688"
    />
    <EcdtToast 
      nome="toast-usuario-inativo"
      variante="aviso"
      texto-corpo="Usuário inativo!"
    />
    <EcdtToast 
      nome="toast-sessao-expirada"
      variante="aviso"
      texto-corpo="Sessão expirada. Por favor, realize o login novamente."
    />
  </div>
</template>

<script>
import Router from '@/router';
import Constants from '@/services/Constants.js';
import _UserService from '@/services/UserService.js';
const UserService = _UserService();
import RequestService from '@/services/RequestService';
import UtilsService from '@/services/Utils.js';
import { addLogLogin } from '@/services/LogsService';
import LogoEconodata from '@/assets/images/logo_menu_azul.png';
import BannerLateral from '@/ecdt-components/login/BannerLateralPaginaLogin.vue';
import EcdtInput from '@/ecdt-components/inputs/EcdtInput.vue';
import AcessoGratuito from '@/ecdt-components/login/AcessoGratuito.vue';
import ModalEsqueciSenha from '@/ecdt-components/modals/ModalEsqueciSenha.vue';
import ModalAvisoTemplate from '@/ecdt-components/modals/ModalAvisoTemplate.vue';
import EcdtToast from '@/ecdt-components/toasts/EcdtToast.vue';

export default {
  components: {
    BannerLateral,
    EcdtInput,
    AcessoGratuito,
    ModalEsqueciSenha,
    ModalAvisoTemplate,
    EcdtToast
  },
  data: () => {
    return {
      UtilsService,
      LogoEconodata,
      carregando: false,
      avisoContaInativa: false,
      avisoUsuarioInativo: false,
      emailUsuario: '',
      senhaUsuario: '',
      modalEsqueciSenhaVisivel: false,
      modalAvisoVisivel: false,
      isTrial: false,
      loginGratuitoVisivel: false,
    };
  },
  watch: {
    avisoContaInativa(valorAtual) {
      if (valorAtual === true) {
        this.$bvToast.show('toast-conta-inativa');
      }
    },
    avisoUsuarioInativo(valorAtual) {
      if (valorAtual === true) {
        this.$bvToast.show('toast-usuario-inativo');
      }
    }
  },
  mounted() {
    UserService.logout()

    window.addEventListener('beforeunload', () => localStorage.removeItem('id_detalhe_empresa'));

    if (this.$route.meta.sessaoExpirada) {
      this.$bvToast.show('toast-sessao-expirada');
    }
    
    if (location.origin.toString().includes('plataforma.econodata.com.br')) {
      window.location.replace('https://plat.econodata.com.br/#/login');
    }

    const uname = this.$route.query.uname;
    const key = this.$route.query.key;

    if (uname && key) {
      this.loginSuporte(uname, key);
    }

    this.mostrarLoginGratuito();
  },
  methods: {
    mostrarLoginGratuito() {
      const hashCdCliente = localStorage.getItem('hash_cd_cliente');
      
      if (!hashCdCliente) {
        return;
      }

      this.loginGratuitoVisivel = true;
    },
    showBtnCriarContaTrial() {
      return process.env.VUE_APP_ENVIROMENT == 'trial';
    },

    redirectCriarContaTrial() {
      window.location.href = "https://www.econodata.com.br/cadastro-trial"
    },

    async verificarUsuarioParaLogin() {
      
      const dominios = ["experimente.econodata.com.br", "hmlplat.econodata.com.br", "plat.econodata.com.br", "hml.experimente.econodata.com.br", "beta.plat.econodata.com.br"];
      const dominio = window.location.host
      // Ajuste pra local
      if(!dominios.includes(dominio)) {
        await this.login()
        return
      }

      const payload = {
        username: this.emailUsuario
      };

      const options = {
        request: {
          url: Constants.api.verificar_usuario_premium,
          payload,
        },
        callback: async (response) => {
          if(response.isPremium) {
            await this.login();
          } else {
            this.isTrial = true;
            await this.login(Constants.api.user_login_trial);
          }
        }
      }

      await RequestService().postRequestPromise(options);
    },
    async login(url = Constants.api.user_login) {
      this.carregando = true;
      const payload = {
        username: this.emailUsuario,
        password: this.senhaUsuario
      };

      const options = {
        request: {
          url,
          payload,
          extraOptions: {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
            xhrFields: {
              withCredentials: true
            }
          },
        },
        callback: async (response, status) => {
          if (response.access_token && response.ecdt_user_info) {
            if(this.isTrial && process.env.VUE_APP_ENVIROMENT != 'trial') {
              window.location.href = process.env.VUE_APP_TRIAL_GET_USER;
              return;
            }
            
            const userInfo = JSON.parse(response.ecdt_user_info);
            addLogLogin(userInfo.id_usuario);

            //mandar push no data layer evento user-login
            window.dataLayer.push({ 'event': 'user-login' });
            UserService.setUserInfo(response.ecdt_user_info);

            // Configuração para testes cypress locais
            if (process.env.VUE_APP_ENVIROMENT == 'dev') {
              window.localStorage.setItem('ecdt-token', response.access_token)
            }
            
            UserService.enviarDadosUserGuiding();

            await UserService.getUserPermissions().then(permissions => {
              UserService.setUserPermissions(permissions);
              this.$store.commit("setarUsuarioPermissoes");
            });

            this.definirPaginaPosLogin();
          } else {
            this.carregando = false;

            // Significa que o usuário trial foi expirado
            if(status === 202) {
              if (this.usuarioQualificado(response.cf_quantidade_de_funcionarios, response.job_title)) {
                window.location.href = 'https://contrate.econodata.com.br/prospectar-experimente';
              }
              else{
                window.location.href = 'https://prospecte.econodata.com.br/econodata-lite';
              }
            }
          }
        },
        errorCallback: error => {
          this.carregando = false;
          this.avisoContaInativa = false;
          this.avisoUsuarioInativo = false;

          if (!error.responseJSON && error.responseJSON != null) {
            this.avisoContaInativa = true;
          }

          if (error.responseText === 'Usuário inativo!') {
            this.avisoUsuarioInativo = true;
          }

          if (!this.avisoContaInativa && !this.avisoUsuarioInativo) {
            this.$bvToast.show('toast-login-incorreto');
          }

          console.error('Erro ao logar: ', error);
        }
      };

      await RequestService().postRequestPromise(options);
    },
    usuarioQualificado(qtdFuncionarios, cargo) {
      return !(qtdFuncionarios == '1-4' || cargo == 'Autônomo/Representante');
    },
    definirPaginaPosLogin() {
      if(this.isTrial && process.env.VUE_APP_ENVIROMENT != 'trial') {
        window.location.href = 'experimente.econodata.com.br/#/get-user-info';
        return;
      }

      const idDetalheEmpresa = localStorage.getItem('id_detalhe_empresa');
      // URL salva antes do usuario ser mandado para o sessao expirada
      const urlRedirecionamento = localStorage.getItem('url_redirecionamento')

      if (idDetalheEmpresa) {
        Router.push({ name: 'Detalhe empresa', params: { id: idDetalheEmpresa }});
        localStorage.removeItem('id_detalhe_empresa');  
      } else {
        if (UserService.userPerfilGratuito()) {
          Router.push({ name: 'Busca Empresa' });
        }
        else if(UserService.userIsTrial()){
          Router.push({ name: 'Home' });
        }
        else if (urlRedirecionamento.includes('users')) {
          Router.push({ name: 'Usuários' });
        } else {
          Router.push({ name: 'Home' });
        }
      }
    },
    loginSuporte(uname, key) {
      var loginSuporteRequest = {
        callback: async response => {
          UserService.setUserInfo(response.ecdt_user_info);
          await UserService.getUserPermissions().then(permissions => {
            UserService.setUserPermissions(permissions);
            this.$store.commit("setarUsuarioPermissoes");
          });
          Router.push({ name: 'Home' });
        },
        errorCallback: () => {
          console.error('erro ao logar suporte');
        },
        request: {
          url: Constants.api.login_suporte,
          payload: {
            uname: uname,
            key: key
          }
        }
      };
      RequestService().postRequest(loginSuporteRequest);
    },
    fecharModal(modal) {
      if (modal === 'esqueci-senha') {
        this.modalEsqueciSenhaVisivel = false;
      } else if (modal === 'aviso') {
        this.modalAvisoVisivel = false;
      }
    },
    abrirModal(modal) {
      if (modal === 'aviso') {
        this.fecharModal('esqueci-senha');
        this.modalAvisoVisivel = true;
      }
    }
  },
};
</script>
